export type Theme = 'dark' | 'light' | 'system';

export const DEFAULT_STORAGE_KEY = 'vite-ui-theme';

export type ResolvedTheme = 'dark' | 'light';

/** Resolve theme to a concrete light/dark value for the document. */
export function getResolvedTheme(theme: Theme, systemPrefersDark: boolean): ResolvedTheme {
  if (theme === 'system') {
    return systemPrefersDark ? 'dark' : 'light';
  }
  return theme;
}
